import PropTypes from 'prop-types'
import React from 'react'

import Icon from 'components/Icon'
import { Text } from 'styles/components/typography'

import {
  CircleIcon,
  Wrapper,
  Circle,
  CircleContainer,
  Description,
} from './styles'

/**
 * IconInCircle component to show icons inside circle
 * @param {object} props - properties of component
 * @return {Component} Component — IconInCircle
 */
const IconInCircle = props => {
  const {
    icon,
    iconBottom,
    iconLeft,
    iconTop,
    iconH,
    iconW,
    description,
  } = props

  return (
    <CircleContainer>
      <Wrapper>
        <Circle />
        <CircleIcon
          iconH={iconH}
          iconW={iconW}
          iconLeft={iconLeft}
          iconTop={iconTop}
          iconBottom={iconBottom}
        >
          <Icon id={icon} />
        </CircleIcon>
      </Wrapper>
      {description ? (
        <Description>
          <Text dangerouslySetInnerHTML={{ __html: description }} />
        </Description>
      ) : null}
    </CircleContainer>
  )
}

IconInCircle.propTypes = {
  /** Code of icon (look at Icon component) */
  icon: PropTypes.string.isRequired,

  /** Description */
  description: PropTypes.string,

  /** Icon bottom position */
  iconBottom: PropTypes.string,

  /** Icon height */
  iconH: PropTypes.string,

  /** Icon left poisition */
  iconLeft: PropTypes.string,

  /** Icon top position */
  iconTop: PropTypes.string,

  /** Icon width */
  iconW: PropTypes.string,
}

IconInCircle.defaultProps = {
  description: '',
  iconBottom: 'auto',
  iconH: '100%',
  iconLeft: '0',
  iconTop: '0',
  iconW: '100%',
}

export default IconInCircle
